// extracted by mini-css-extract-plugin
export var backdrop = "Modal-module--backdrop--vFtJj";
export var close = "Modal-module--close--VOP9I";
export var closeIcon = "Modal-module--closeIcon--lGtjW";
export var component = "Modal-module--component--yiUDS";
export var container = "Modal-module--container--1U6Qr";
export var content = "Modal-module--content--b4HS2";
export var inner = "Modal-module--inner--P8pFR";
export var toggle = "Modal-module--toggle--FXbxp";